import cx from 'classnames'
import { useDevice } from 'device'
import { useEventListener } from 'hooks'
import React, { useMemo, useState } from 'react'
import { useModuleTitle } from 'models/settings'

import { HeaderButton } from 'components/inputs'
import { Carousel } from 'components/dataDisplay'

import EventCard from './components/EventCard/EventCard'

import useEvents from './util/useEvents'

import s from './EventsBlock.scss'

import noEventImage from './images/noEventImage.png'


type EventsBlockProps = {
  className?: string
  to: string
}

const EventsBlock: React.FC<EventsBlockProps> = (props) => {
  const { className, to } = props

  const { title: moduleTitle } = useModuleTitle('POSTER')

  const { events, isFetching, handleToggleBookmark } = useEvents()

  const { isMobile, isTablet } = useDevice()
  const [ width, setWidth ] = useState(typeof window !== 'undefined' ? window.innerWidth : null)

  useEventListener('resize', () => setWidth(window.innerWidth))

  const eventsList = useMemo(() => {
    if (events) {
      if (isTablet) {
        return events.filter((event, index) => index < 2)
      }
    }

    return events
  }, [ events, isTablet ])

  const eventsNode = (
    eventsList.map(({ id, title, bookmarked, start, end, type, image, to }, index) => (
      <EventCard
        className={cx(s.card, 'flex-1', { 'ml-32px': !isMobile && index })}
        key={id}
        title={title}
        bookmarked={bookmarked}
        start={start}
        end={end}
        type={type}
        image={image || noEventImage}
        style={{ height: '183px' }}
        to={to}
        handleBookmarkClick={() => handleToggleBookmark(id)}
      />
    ))
  )

  return (
    <div className={cx(className)}>
      <HeaderButton
        title={moduleTitle}
        size={isMobile ? 'h20-24' : 'h32'}
        to={to}
      />
      {
        events && (
          isMobile ? (
            <Carousel
              className={cx(s.carousel, 'mt-32px')}
              slidesToShow={1}
              slidesToScroll={1}
              exactWidth={typeof window !== 'undefined'}
              itemWidth={typeof window !== 'undefined' ? width - 32 : null}
              draggable
            >
              {eventsNode}
            </Carousel>
          ) : (
            <div className="flex mt-32px">
              {eventsNode}
            </div>
          )
        )
      }
    </div>
  )
}

export default EventsBlock